<template>
	<div class="h-120 flex items-center justify-between bg-#0F0F17">
		<div @click="reToPage(item.key)" v-for="(item, index) in menuList" class="flex-1 flex flex-col items-center justify-center">
			<img v-if="activeMenu === item.key" class="w-46 h-46" :src="item.activeIcon" alt="">
			<img v-else class="w-46 h-46" :src="item.icon" alt="">
			<span class="mt-4 text-20" :class="[activeMenu === item.key ? 'text-white' : 'text-#999']">{{
				$t(item.nameKey) }}</span>
		</div>
	</div>
</template>

<script>
import utils from "@/utils/utils.js";
export default {
	components: {
	},
	props: {
		activeMenu: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			menuList: [
				{
					id: 1,
					nameKey: '销毁挖矿.销毁挖矿',
					key: 'destroy-mining',
					// 使用require导入图片
					icon: require('@/assets/images/pages/destroy-mining/destroy_mining.png'),
					activeIcon: require('@/assets/images/pages/destroy-mining/destroy_mining_active.png'),
					path: "/home"
				},
				{
					id: 2,
					nameKey: '销毁挖矿.团队',
					key: 'destroy-team',
					icon: require('@/assets/images/pages/destroy-mining/destroy_team.png'),
					activeIcon: require('@/assets/images/pages/destroy-mining/destroy_team_active.png'),
					path: "/node"
				},
			]
		};
	},
	computed: {},
	created() { },
	methods: {
		reToPage(path) {
			console.log(path);
			utils.reToPage(path);
		},
	},
}
</script>

<style></style>
